export const columns = [
  {
    title: "投标报价编号",
    width: 200,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "投标报价（¥）",
    width: 180,
    dataIndex: "offerPrice",
    key: "offerPrice",
  },
  {
    title: "投标负责人",
    width: 180,
    dataIndex: "responsibleTenantUserName",
    key: "responsibleTenantUserName",
  },
  {
    title: "备注",
    width: 300,
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "最近更新时间",
    width: 200,
    dataIndex: "lastModifiedTime",
    key: "lastModifiedTime",
  },
  {
    title: "生效状态",
    width: 120,
    dataIndex: "validStatusName",
    key: "validStatusName",
  },
];
